import {ActionTypes} from "../contants/action-type.js";
import {
    getRestaurants,
    createRestaurant,
    updateRestaurant,
    deleteRestaurant,
    getSelectedRestaurant,
    changeStatusRestaurant
} from '../../services/RestaurantService.js';

export function getRestaurantsAction() {
    return (dispatch) => {
        getRestaurants().then((response) => {
            dispatch(listRestaurants(response.data));
        });
    };
}

export function getRestaurantAction() {
    return (dispatch, getState) => {
        getRestaurants().then((response) => {
            dispatch(listRestaurants(response.data));
        });
    };
}

export function getSelectedRestaurantAction(id) {
    return (dispatch, getState) => {
        getSelectedRestaurant(id).then((response) => {
            dispatch(selectedRestaurant(response.data));
        });
    };
}
export function createRestaurantAction(restaurant, history) {
    return (dispatch, getState) => {
        createRestaurant(restaurant).then((response) => {
            dispatch(confirmCreateRestaurant(response.data));
            history.push('/vendor');
        });
    };
}

export function updateRestaurantAction(restaurant,id, history) {
    return (dispatch, getState) => {
        console.log(restaurant);
        updateRestaurant(restaurant,id).then((response) => {
            dispatch(confirmEditRestaurant(response.data));
            history.push('/vendor');
        });
    };
}

export function changeStatusRestaurantAction(restaurant, id, history) {
    return (dispatch, getState) => {
        changeStatusRestaurant(restaurant, id).then((response) => {
            dispatch(listRestaurants(response.data));
            history.push('/vendor');
        });
    };
}
export function deleteRestaurantAction(id, history) {
    return (dispatch, getState) => {
        deleteRestaurant(id).then((response) => {
            console.log(response);
            dispatch(listRestaurants(response.data));
            history.push('/vendor');
        });
    };
}
export const listRestaurants = (restautants) => {
    return {
        type: ActionTypes.LIST_RESTAURANT,
        payload: restautants
    }
}
export const confirmCreateRestaurant = (restaurant) => {
    return {
        type: ActionTypes.CONFIRM_CREATE_RESTAURANT,
        payload: restaurant
    }
}
export const confirmEditRestaurant = (restaurant) => {
    return {
        type: ActionTypes.CONFIRM_EDIT_RESTAURANT,
        payload: restaurant
    }
}
export const selectedRestaurant = (restaurant) => {
    return {
        type: ActionTypes.SELECTED_RESTAURANT,
        payload: restaurant
    }
}
export const confirmDeleteRestaurant = (restaurant) => {
    return {
        type: ActionTypes.CONFIRM_DELETE_RESTAURANT,
        payload: restaurant
    }
}